import {
    SET_PAGE_TYPE,
    DISMISS_HOME_INTRO,
    ADD_MEDIA_ITEM,
    REMOVE_MEDIA_ITEM,
    SET_LOCATION_NAV,
    TOGGLE_MAP_NAV,
} from 'framework/vuex/mutation-types';


export function setPageType({ commit }, { pageType }) {
    commit(SET_PAGE_TYPE, { pageType });
}

export function dismissHomeIntro({ commit }, { isHomeIntroDismissed }) {
    commit(TOGGLE_MAP_NAV, { toggle: false });
    commit(DISMISS_HOME_INTRO, { isHomeIntroDismissed });
}

export function addMediaItem({ commit }, { item }) {
    commit(ADD_MEDIA_ITEM, { item });
}

export function removeMediaItem({ commit }, { item }) {
    commit(REMOVE_MEDIA_ITEM, { item });
}

export function setLocationNav({ commit }, { nav }) {
    commit(SET_LOCATION_NAV, { nav });
}

export function toggleMapNav({ commit }, { toggle }) {
    commit(TOGGLE_MAP_NAV, { toggle });
}



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/vuex/modules/project/actions.js